import type React from 'react';
import { useEffect, useRef } from 'react';
import styles from './TestExecution.module.css';

export interface ConsoleOutputEntry {
  type: string;
  data: string;
}

interface ConsoleOutputProps {
  output: ConsoleOutputEntry[];
  visible: boolean;
}

export const ConsoleOutput: React.FC<ConsoleOutputProps> = ({ output, visible }) => {
  const consoleRef = useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: output triggers auto-scroll
  useEffect(() => {
    if (consoleRef.current) {
      consoleRef.current.scrollTop = consoleRef.current.scrollHeight;
    }
  }, [output]);

  if (!visible) return null;

  return (
    <div className={styles.consoleContainer} ref={consoleRef}>
      {output.map((line, index) => (
        <div key={index} className={styles.consoleLine} data-type={line.type}>
          {line.data}
        </div>
      ))}
    </div>
  );
};
